var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgForfeitJobi = function SvgForfeitJobi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1602"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M21 10V7.61a2.053 2.053 0 0 0-2-2.1h-2.98v-.86A1.61 1.61 0 0 0 14.45 3h-4.9a1.61 1.61 0 0 0-1.57 1.65v.86H5a2.053 2.053 0 0 0-2 2.1V18.9A2.053 2.053 0 0 0 5 21h14a2.053 2.053 0 0 0 2-2.1v-4.484a1.89 1.89 0 0 0-1.877-1.893H12.46v-2.082L9.644 13.28l2.816 2.839v-2.078h6.663a.377.377 0 0 1 .375.379v4.37a.585.585 0 0 1-.5.63H5a.578.578 0 0 1-.5-.63V7.67a.548.548 0 0 1 .5-.58h14a.548.548 0 0 1 .5.58V10zm-6.48-4.49H9.51l.04-.93 4.97.07z",
    "data-name": "Path 4851"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgForfeitJobi);
export default ForwardRef;